const key = 'bnw-account-type';
const endpoints = {
  STAFF: { me: '/auth/me', refresh: '/auth/refresh' },
  CLIENT: { me: '/clients/me', refresh: '/clients/refresh' },
  STUDENT: { me: '/student/me', refresh: '/student/refresh' },
  PARTNER: { me: '/partners/me', refresh: '/partnerauth/refresh' },
};
// This browser hint chooses endpoints only. The backend determines identity
// from the signed session and current database record on every request.
export function setSessionAccountType(type) {
  try {
    if (endpoints[type]) window.localStorage.setItem(key, type);
    else window.localStorage.removeItem(key);
  } catch {}
}
export function sessionEndpoints() {
  let type;
  try { type = window.localStorage.getItem(key); } catch {}
  if (!endpoints[type] && typeof window !== 'undefined') {
    const path = window.location.pathname;
    if (/^\/clientdashboard(\/|$)/.test(path)) type = 'CLIENT';
    else if (/^\/studentdashboard(\/|$)/.test(path)) type = 'STUDENT';
    else if (/^\/partnerdashboard(\/|$)/.test(path)) type = 'PARTNER';
  }
  return endpoints[type] || endpoints.STAFF;
}
